import api from 'api'

export const createForm = async (projectId, payload) => {
  const { data } = await api.post(`/project/${projectId}/form`, payload)

  return data
}
